export default __webpack_public_path__ + "static/media/sr-nilson-lucas.cd4a8a9b.jpg";